import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, vModelRadio as _vModelRadio, withKeys as _withKeys, renderSlot as _renderSlot, Transition as _Transition, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7571bf3d")

_pushScopeId("data-v-7571bf3d")
const _hoisted_1 = { class: "details-edit" }
const _hoisted_2 = { class: "modal-details-edit" }
const _hoisted_3 = { class: "modal-mask" }
const _hoisted_4 = { class: "modal-wrapper" }
const _hoisted_5 = { class: "modal-container" }
const _hoisted_6 = { class: "modal-header" }
const _hoisted_7 = { name: "header" }
const _hoisted_8 = /*#__PURE__*/_createVNode("h3", null, "Update Committee Contact Details", -1)
const _hoisted_9 = {
  key: 0,
  class: "modal-body"
}
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-6" }
const _hoisted_12 = { class: "input-box" }
const _hoisted_13 = /*#__PURE__*/_createVNode("label", null, [
  /*#__PURE__*/_createVNode("h4", null, "First Name")
], -1)
const _hoisted_14 = {
  ref: "firstName",
  class: "firstClass",
  type: "text",
  placeholder: "First Name",
  maxlength: "50"
}
const _hoisted_15 = { class: "col-6" }
const _hoisted_16 = { class: "input-box" }
const _hoisted_17 = /*#__PURE__*/_createVNode("label", null, [
  /*#__PURE__*/_createVNode("h4", null, "Surname")
], -1)
const _hoisted_18 = {
  ref: "firstName",
  class: "firstClass",
  type: "text",
  placeholder: "Surname",
  maxlength: "50"
}
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "col-6" }
const _hoisted_21 = { class: "input-box" }
const _hoisted_22 = /*#__PURE__*/_createVNode("label", null, [
  /*#__PURE__*/_createVNode("h4", null, "Law Society Member")
], -1)
const _hoisted_23 = {
  ref: "firstName",
  class: "firstClass",
  type: "text",
  placeholder: "Law Society Member",
  maxlength: "50"
}
const _hoisted_24 = { class: "col-6" }
const _hoisted_25 = { class: "input-box" }
const _hoisted_26 = /*#__PURE__*/_createVNode("label", null, [
  /*#__PURE__*/_createVNode("h4", null, "Type of Solicitor")
], -1)
const _hoisted_27 = {
  ref: "firstName",
  class: "firstClass",
  type: "text",
  placeholder: "Type of Solicitor",
  maxlength: "50"
}
const _hoisted_28 = { class: "modal-body" }
const _hoisted_29 = {
  key: 0,
  class: "row"
}
const _hoisted_30 = { class: "col-6" }
const _hoisted_31 = { class: "input-box" }
const _hoisted_32 = /*#__PURE__*/_createVNode("label", null, [
  /*#__PURE__*/_createVNode("h4", null, "Firm / Organisation Name *")
], -1)
const _hoisted_33 = {
  key: 0,
  class: "validation-msg ma-1"
}
const _hoisted_34 = /*#__PURE__*/_createVNode("i", { class: "fal fa-exclamation-circle" }, null, -1)
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" Mandatory field ")
const _hoisted_36 = { class: "row" }
const _hoisted_37 = { class: "col-6" }
const _hoisted_38 = { class: "input-box" }
const _hoisted_39 = /*#__PURE__*/_createVNode("label", null, [
  /*#__PURE__*/_createVNode("h4", null, "Phone Number (Optional)")
], -1)
const _hoisted_40 = { style: {"width":"39%","float":"left"} }
const _hoisted_41 = { style: {"width":"59%","float":"right"} }
const _hoisted_42 = { class: "col-6" }
const _hoisted_43 = { class: "input-box" }
const _hoisted_44 = /*#__PURE__*/_createVNode("label", null, [
  /*#__PURE__*/_createVNode("h4", null, "Committee Email Address *")
], -1)
const _hoisted_45 = {
  key: 0,
  class: "validation-msg ma-1"
}
const _hoisted_46 = /*#__PURE__*/_createVNode("i", { class: "fal fa-exclamation-circle" }, null, -1)
const _hoisted_47 = { key: 0 }
const _hoisted_48 = { key: 1 }
const _hoisted_49 = { class: "row" }
const _hoisted_50 = { class: "col-6" }
const _hoisted_51 = /*#__PURE__*/_createVNode("label", null, [
  /*#__PURE__*/_createVNode("h4", null, "Country/Region *")
], -1)
const _hoisted_52 = {
  key: 0,
  class: "loading-indicator",
  style: {"height":"60px"}
}
const _hoisted_53 = /*#__PURE__*/_createVNode("div", { class: "ma-3" }, [
  /*#__PURE__*/_createVNode("span", null, [
    /*#__PURE__*/_createVNode("i", { class: "fa fa-spinner fa-spin fa-2x" })
  ]),
  /*#__PURE__*/_createVNode("span", null, " Loading Countries ...")
], -1)
const _hoisted_54 = {
  key: 1,
  class: "select"
}
const _hoisted_55 = /*#__PURE__*/_createVNode("option", {
  value: "",
  style: {"color":"#eee"},
  selected: "",
  disabled: ""
}, "- Please select -", -1)
const _hoisted_56 = {
  key: 2,
  class: "validation-msg ma-1"
}
const _hoisted_57 = /*#__PURE__*/_createVNode("i", { class: "fal fa-exclamation-circle" }, null, -1)
const _hoisted_58 = /*#__PURE__*/_createTextVNode(" Mandatory field ")
const _hoisted_59 = { key: 1 }
const _hoisted_60 = /*#__PURE__*/_createVNode("div", { class: "row" }, [
  /*#__PURE__*/_createVNode("div", {
    class: "col-4",
    style: {"margin-bottom":"-8px"}
  }, [
    /*#__PURE__*/_createVNode("h4", null, "Address Type *")
  ])
], -1)
const _hoisted_61 = { class: "row" }
const _hoisted_62 = {
  class: "col-4",
  style: {"min-width":"100px"}
}
const _hoisted_63 = { class: "radio outline" }
const _hoisted_64 = /*#__PURE__*/_createVNode("label", { for: "addressType_0" }, [
  /*#__PURE__*/_createVNode("h4", null, "Street")
], -1)
const _hoisted_65 = {
  class: "col-4",
  style: {"min-width":"100px"}
}
const _hoisted_66 = { class: "radio outline" }
const _hoisted_67 = /*#__PURE__*/_createVNode("label", { for: "addressType_1" }, [
  /*#__PURE__*/_createVNode("h4", null, "PO Box")
], -1)
const _hoisted_68 = { key: 0 }
const _hoisted_69 = { class: "row" }
const _hoisted_70 = { class: "col-8" }
const _hoisted_71 = { class: "input-box" }
const _hoisted_72 = /*#__PURE__*/_createVNode("label", null, [
  /*#__PURE__*/_createVNode("h4", null, "Building Name (Optional)")
], -1)
const _hoisted_73 = { class: "row" }
const _hoisted_74 = { class: "col-4" }
const _hoisted_75 = /*#__PURE__*/_createVNode("label", null, [
  /*#__PURE__*/_createVNode("h4", null, "Building Type (Optional)")
], -1)
const _hoisted_76 = {
  key: 0,
  class: "select"
}
const _hoisted_77 = /*#__PURE__*/_createVNode("option", {
  selected: "",
  value: ""
}, "- Please select -", -1)
const _hoisted_78 = { class: "col-3" }
const _hoisted_79 = { class: "input-box" }
const _hoisted_80 = /*#__PURE__*/_createVNode("label", null, [
  /*#__PURE__*/_createVNode("h4", null, "Building Number (Optional)")
], -1)
const _hoisted_81 = { class: "col-3" }
const _hoisted_82 = { class: "input-box" }
const _hoisted_83 = /*#__PURE__*/_createVNode("label", null, [
  /*#__PURE__*/_createVNode("h4", null, "Level / Floor (Optional)")
], -1)
const _hoisted_84 = { class: "row" }
const _hoisted_85 = { class: "col-3" }
const _hoisted_86 = { class: "input-box" }
const _hoisted_87 = /*#__PURE__*/_createVNode("label", null, [
  /*#__PURE__*/_createVNode("h4", null, "Street Number *")
], -1)
const _hoisted_88 = {
  key: 0,
  class: "validation-msg ma-1"
}
const _hoisted_89 = /*#__PURE__*/_createVNode("i", { class: "fal fa-exclamation-circle" }, null, -1)
const _hoisted_90 = /*#__PURE__*/_createTextVNode(" Mandatory field ")
const _hoisted_91 = { class: "col-5" }
const _hoisted_92 = { class: "input-box" }
const _hoisted_93 = /*#__PURE__*/_createVNode("label", null, [
  /*#__PURE__*/_createVNode("h4", null, "Street Name *")
], -1)
const _hoisted_94 = {
  key: 0,
  class: "validation-msg ma-1"
}
const _hoisted_95 = /*#__PURE__*/_createVNode("i", { class: "fal fa-exclamation-circle" }, null, -1)
const _hoisted_96 = /*#__PURE__*/_createTextVNode(" Mandatory field ")
const _hoisted_97 = { class: "col-4" }
const _hoisted_98 = /*#__PURE__*/_createVNode("label", null, [
  /*#__PURE__*/_createVNode("h4", null, "Street Type *")
], -1)
const _hoisted_99 = {
  key: 0,
  class: "select"
}
const _hoisted_100 = /*#__PURE__*/_createVNode("option", {
  value: "",
  disabled: ""
}, "- Please select -", -1)
const _hoisted_101 = {
  key: 0,
  class: "validation-msg ma-1"
}
const _hoisted_102 = /*#__PURE__*/_createVNode("i", { class: "fal fa-exclamation-circle" }, null, -1)
const _hoisted_103 = /*#__PURE__*/_createTextVNode(" Mandatory field ")
const _hoisted_104 = { key: 1 }
const _hoisted_105 = { class: "row" }
const _hoisted_106 = { class: "col-8" }
const _hoisted_107 = /*#__PURE__*/_createVNode("label", null, [
  /*#__PURE__*/_createVNode("h4", null, "Delivery Type *")
], -1)
const _hoisted_108 = {
  key: 0,
  class: "select"
}
const _hoisted_109 = /*#__PURE__*/_createVNode("option", {
  value: "",
  disabled: ""
}, "- Please select -", -1)
const _hoisted_110 = {
  key: 1,
  class: "validation-msg ma-1"
}
const _hoisted_111 = /*#__PURE__*/_createVNode("i", { class: "fal fa-exclamation-circle" }, null, -1)
const _hoisted_112 = /*#__PURE__*/_createTextVNode(" Mandatory field ")
const _hoisted_113 = { class: "row" }
const _hoisted_114 = { class: "col-8" }
const _hoisted_115 = { class: "input-box" }
const _hoisted_116 = /*#__PURE__*/_createVNode("label", null, [
  /*#__PURE__*/_createVNode("h4", null, "PO Box *")
], -1)
const _hoisted_117 = {
  key: 0,
  class: "validation-msg ma-1"
}
const _hoisted_118 = /*#__PURE__*/_createVNode("i", { class: "fal fa-exclamation-circle" }, null, -1)
const _hoisted_119 = /*#__PURE__*/_createTextVNode(" Mandatory field ")
const _hoisted_120 = { key: 2 }
const _hoisted_121 = { class: "row" }
const _hoisted_122 = { class: "col-12 autocomplete" }
const _hoisted_123 = /*#__PURE__*/_createVNode("h4", null, [
  /*#__PURE__*/_createTextVNode("Search "),
  /*#__PURE__*/_createVNode("small", null, "(Enter Suburb name or Postcode to search)")
], -1)
const _hoisted_124 = { class: "icon" }
const _hoisted_125 = {
  key: 0,
  class: "fas fa-spinner fa-spin"
}
const _hoisted_126 = {
  key: 0,
  id: "autocomplete-results",
  class: "autocomplete-results"
}
const _hoisted_127 = { class: "row" }
const _hoisted_128 = { class: "col-4" }
const _hoisted_129 = /*#__PURE__*/_createVNode("h4", null, "Suburb *", -1)
const _hoisted_130 = {
  key: 0,
  class: "validation-msg ma-1"
}
const _hoisted_131 = /*#__PURE__*/_createVNode("i", { class: "fal fa-exclamation-circle" }, null, -1)
const _hoisted_132 = /*#__PURE__*/_createTextVNode(" Mandatory field ")
const _hoisted_133 = { class: "col-3" }
const _hoisted_134 = /*#__PURE__*/_createVNode("h4", null, "Post Code *", -1)
const _hoisted_135 = {
  key: 0,
  class: "validation-msg ma-1"
}
const _hoisted_136 = /*#__PURE__*/_createVNode("i", { class: "fal fa-exclamation-circle" }, null, -1)
const _hoisted_137 = /*#__PURE__*/_createTextVNode(" Mandatory field ")
const _hoisted_138 = { class: "col-5" }
const _hoisted_139 = { class: "input-box" }
const _hoisted_140 = /*#__PURE__*/_createVNode("label", null, [
  /*#__PURE__*/_createVNode("h4", null, "State *")
], -1)
const _hoisted_141 = {
  key: 0,
  class: "validation-msg ma-1"
}
const _hoisted_142 = /*#__PURE__*/_createVNode("i", { class: "fal fa-exclamation-circle" }, null, -1)
const _hoisted_143 = /*#__PURE__*/_createTextVNode(" Mandatory field ")
const _hoisted_144 = {
  key: 2,
  class: "row"
}
const _hoisted_145 = { class: "col-12" }
const _hoisted_146 = /*#__PURE__*/_createVNode("label", null, [
  /*#__PURE__*/_createVNode("h4", null, "Enter Full Address *")
], -1)
const _hoisted_147 = {
  key: 0,
  class: "validation-msg ma-1"
}
const _hoisted_148 = /*#__PURE__*/_createVNode("i", { class: "fal fa-exclamation-circle" }, null, -1)
const _hoisted_149 = /*#__PURE__*/_createTextVNode(" Mandatory field ")
const _hoisted_150 = {
  class: "small ma-3 pa-2",
  style: {"background-color":"#eee","border":"1px solid #eee","box-shadow":"0 2px 2px 0 rgba(0,0,0,0.25)"}
}
const _hoisted_151 = /*#__PURE__*/_createVNode("small", null, "Address Preview:", -1)
const _hoisted_152 = /*#__PURE__*/_createVNode("small", { class: "ml-3 ls-slate-light" }, " * Denotes mandatory field ", -1)
const _hoisted_153 = { class: "modal-footer row" }
const _hoisted_154 = { class: "col-12" }
const _hoisted_155 = /*#__PURE__*/_createTextVNode("Save Details")
const _hoisted_156 = /*#__PURE__*/_createVNode("span", null, [
  /*#__PURE__*/_createVNode("i", { class: "fal fa-angle-right" })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx, _cache) => {
  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_Transition, { name: "modal" }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode("div", _hoisted_5, [
                _createVNode("div", _hoisted_6, [
                  _createVNode("div", _hoisted_7, [
                    _hoisted_8,
                    _createVNode("p", null, _toDisplayString(_ctx.displayName), 1),
                    _createVNode("i", {
                      class: "fal fa-times-circle close-icon",
                      onClick: _cache[1] || (_cache[1] = $event => {_ctx.resetForm();})
                    })
                  ])
                ]),
                (_ctx.editType == 1)
                  ? (_openBlock(), _createBlock("div", _hoisted_9, [
                      _createVNode("div", _hoisted_10, [
                        _createVNode("div", _hoisted_11, [
                          _createVNode("div", _hoisted_12, [
                            _hoisted_13,
                            _createVNode("input", _hoisted_14, null, 512)
                          ])
                        ]),
                        _createVNode("div", _hoisted_15, [
                          _createVNode("div", _hoisted_16, [
                            _hoisted_17,
                            _createVNode("input", _hoisted_18, null, 512)
                          ])
                        ])
                      ]),
                      _createVNode("div", _hoisted_19, [
                        _createVNode("div", _hoisted_20, [
                          _createVNode("div", _hoisted_21, [
                            _hoisted_22,
                            _createVNode("input", _hoisted_23, null, 512)
                          ])
                        ]),
                        _createVNode("div", _hoisted_24, [
                          _createVNode("div", _hoisted_25, [
                            _hoisted_26,
                            _createVNode("input", _hoisted_27, null, 512)
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_28, [
                  (!_ctx.isPcHolder)
                    ? (_openBlock(), _createBlock("div", _hoisted_29, [
                        _createVNode("div", _hoisted_30, [
                          _createVNode("div", _hoisted_31, [
                            _hoisted_32,
                            _withDirectives(_createVNode("input", {
                              ref: "firmRef",
                              class: "firmName",
                              type: "text",
                              placeholder: "Firm / Organisation Name",
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (_ctx.firmName = $event)),
                              onInput: _cache[3] || (_cache[3] = $event => (_ctx.mandatoryCheck())),
                              onBlur: _cache[4] || (_cache[4] = $event => (_ctx.isFirmNameValid())),
                              maxlength: "50"
                            }, null, 544), [
                              [_vModelText, _ctx.firmName]
                            ]),
                            (_ctx.firmName.trim() === '')
                              ? (_openBlock(), _createBlock("span", _hoisted_33, [
                                  _hoisted_34,
                                  _hoisted_35
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_36, [
                    _createVNode("div", _hoisted_37, [
                      _createVNode("div", _hoisted_38, [
                        _hoisted_39,
                        _createVNode("span", _hoisted_40, [
                          _withDirectives(_createVNode("input", {
                            ref: "areaCodeRef",
                            style: {"width":"100%"},
                            class: "acode",
                            type: "text",
                            placeholder: "Area Code",
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (_ctx.phoneAreaCode = $event)),
                            maxlength: "10"
                          }, null, 512), [
                            [_vModelText, _ctx.phoneAreaCode]
                          ])
                        ]),
                        _createVNode("span", _hoisted_41, [
                          _withDirectives(_createVNode("input", {
                            ref: "phoneRef",
                            style: {"width":"100%"},
                            class: "phone",
                            type: "text",
                            placeholder: "Phone Number",
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => (_ctx.phone = $event)),
                            maxlength: "30"
                          }, null, 512), [
                            [_vModelText, _ctx.phone]
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_42, [
                      _createVNode("div", _hoisted_43, [
                        _hoisted_44,
                        _withDirectives(_createVNode("input", {
                          ref: "emailRef",
                          class: "email",
                          type: "text",
                          placeholder: "Committee Email Address",
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => (_ctx.email = $event)),
                          onInput: _cache[8] || (_cache[8] = $event => (_ctx.mandatoryCheck())),
                          onBlur: _cache[9] || (_cache[9] = $event => (_ctx.isEmailAddressValid()))
                        }, null, 544), [
                          [_vModelText, _ctx.email]
                        ]),
                        (!_ctx.validEmail)
                          ? (_openBlock(), _createBlock("span", _hoisted_45, [
                              _hoisted_46,
                              (_ctx.email.trim() === '')
                                ? (_openBlock(), _createBlock("span", _hoisted_47, " Mandatory field"))
                                : (_openBlock(), _createBlock("span", _hoisted_48, " Invalid Email Address"))
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_49, [
                    _createVNode("div", _hoisted_50, [
                      _hoisted_51,
                      (!_ctx.countryList)
                        ? (_openBlock(), _createBlock("div", _hoisted_52, [
                            _hoisted_53
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.countryList)
                        ? (_openBlock(), _createBlock("div", _hoisted_54, [
                            _withDirectives(_createVNode("select", {
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => (_ctx.country = $event)),
                              ref: "countryRef",
                              id: "countrySelection",
                              class: !_ctx.country ? 'placeholder' : '',
                              onChange: _cache[11] || (_cache[11] = $event => (_ctx.setForeignAddress(_ctx.country)))
                            }, [
                              _hoisted_55,
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.countryList, (c) => {
                                return (_openBlock(), _createBlock("option", {
                                  value: {id: c.id, name: c.name}
                                }, _toDisplayString(c.name), 9, ["value"]))
                              }), 256))
                            ], 34), [
                              [_vModelSelect, _ctx.country]
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.country === '')
                        ? (_openBlock(), _createBlock("span", _hoisted_56, [
                            _hoisted_57,
                            _hoisted_58
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  (!_ctx.isOversea && _ctx.country.name == 'AUSTRALIA')
                    ? (_openBlock(), _createBlock("div", _hoisted_59, [
                        _hoisted_60,
                        _createVNode("div", _hoisted_61, [
                          _createVNode("div", _hoisted_62, [
                            _createVNode("div", _hoisted_63, [
                              _withDirectives(_createVNode("input", {
                                type: "radio",
                                name: "addressType",
                                id: "addressType_0",
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => (_ctx.address.addressTypeId = $event)),
                                value: 1,
                                onChange: _cache[13] || (_cache[13] = $event => (_ctx.setAddressType()))
                              }, null, 544), [
                                [_vModelRadio, _ctx.address.addressTypeId]
                              ]),
                              _hoisted_64
                            ])
                          ]),
                          _createVNode("div", _hoisted_65, [
                            _createVNode("div", _hoisted_66, [
                              _withDirectives(_createVNode("input", {
                                type: "radio",
                                name: "addressType",
                                id: "addressType_1",
                                "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => (_ctx.address.addressTypeId = $event)),
                                value: 2,
                                onChange: _cache[15] || (_cache[15] = $event => (_ctx.setAddressType()))
                              }, null, 544), [
                                [_vModelRadio, _ctx.address.addressTypeId]
                              ]),
                              _hoisted_67
                            ])
                          ])
                        ]),
                        (_ctx.address.addressTypeId == 1)
                          ? (_openBlock(), _createBlock("div", _hoisted_68, [
                              _createVNode("div", _hoisted_69, [
                                _createVNode("div", _hoisted_70, [
                                  _createVNode("div", _hoisted_71, [
                                    _hoisted_72,
                                    _withDirectives(_createVNode("input", {
                                      ref: "buildingName",
                                      class: "building-name",
                                      type: "text",
                                      placeholder: "Building Name",
                                      "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => (_ctx.address.buildingName = $event)),
                                      maxlength: "50"
                                    }, null, 512), [
                                      [_vModelText, _ctx.address.buildingName]
                                    ])
                                  ])
                                ])
                              ]),
                              _createVNode("div", _hoisted_73, [
                                _createVNode("div", _hoisted_74, [
                                  _hoisted_75,
                                  (_ctx.buildingTypeList)
                                    ? (_openBlock(), _createBlock("div", _hoisted_76, [
                                        _withDirectives(_createVNode("select", {
                                          "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => (_ctx.buildingType = $event)),
                                          id: "buildingTypeSelection",
                                          class: !_ctx.buildingType ? 'placeholder' : '',
                                          onChange: _cache[18] || (_cache[18] = $event => (_ctx.setBuildingType(_ctx.buildingType)))
                                        }, [
                                          _hoisted_77,
                                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.buildingTypeList, (b) => {
                                            return (_openBlock(), _createBlock("option", {
                                              value: {id: b.id, name: b.description}
                                            }, _toDisplayString(b.description), 9, ["value"]))
                                          }), 256))
                                        ], 34), [
                                          [_vModelSelect, _ctx.buildingType]
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _createVNode("div", _hoisted_78, [
                                  _createVNode("div", _hoisted_79, [
                                    _hoisted_80,
                                    _withDirectives(_createVNode("input", {
                                      ref: "buildingNumber",
                                      class: "building-number",
                                      type: "text",
                                      placeholder: "Building Number",
                                      "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => (_ctx.address.buildingNumber = $event)),
                                      maxlength: "10"
                                    }, null, 512), [
                                      [_vModelText, _ctx.address.buildingNumber]
                                    ])
                                  ])
                                ]),
                                _createVNode("div", _hoisted_81, [
                                  _createVNode("div", _hoisted_82, [
                                    _hoisted_83,
                                    _withDirectives(_createVNode("input", {
                                      ref: "level",
                                      class: "level",
                                      type: "text",
                                      placeholder: "e.g. Level 1 or Floor 25",
                                      "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => (_ctx.address.level = $event)),
                                      maxlength: "50"
                                    }, null, 512), [
                                      [_vModelText, _ctx.address.level]
                                    ])
                                  ])
                                ])
                              ]),
                              _createVNode("div", _hoisted_84, [
                                _createVNode("div", _hoisted_85, [
                                  _createVNode("div", _hoisted_86, [
                                    _hoisted_87,
                                    _withDirectives(_createVNode("input", {
                                      ref: "streetNumber",
                                      class: "street-number",
                                      type: "text",
                                      placeholder: "Street Number",
                                      maxlength: "10",
                                      "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => (_ctx.address.streetNumber = $event)),
                                      onKeyup: _cache[22] || (_cache[22] = $event => (_ctx.mandatoryCheck())),
                                      onBlur: _cache[23] || (_cache[23] = $event => (_ctx.isStreetNumberValid()))
                                    }, null, 544), [
                                      [_vModelText, _ctx.address.streetNumber]
                                    ]),
                                    (_ctx.address.streetNumber.trim() === '')
                                      ? (_openBlock(), _createBlock("span", _hoisted_88, [
                                          _hoisted_89,
                                          _hoisted_90
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _createVNode("div", _hoisted_91, [
                                  _createVNode("div", _hoisted_92, [
                                    _hoisted_93,
                                    _withDirectives(_createVNode("input", {
                                      ref: "streetName",
                                      class: "street-name",
                                      type: "text",
                                      placeholder: "Street Name",
                                      maxlength: "50",
                                      "onUpdate:modelValue": _cache[24] || (_cache[24] = $event => (_ctx.address.streetName = $event)),
                                      onKeyup: _cache[25] || (_cache[25] = $event => (_ctx.mandatoryCheck())),
                                      onBlur: _cache[26] || (_cache[26] = $event => (_ctx.isStreetNameValid()))
                                    }, null, 544), [
                                      [_vModelText, _ctx.address.streetName]
                                    ]),
                                    (_ctx.address.streetName.trim() === '')
                                      ? (_openBlock(), _createBlock("span", _hoisted_94, [
                                          _hoisted_95,
                                          _hoisted_96
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _createVNode("div", _hoisted_97, [
                                  _hoisted_98,
                                  (_ctx.streetTypeList)
                                    ? (_openBlock(), _createBlock("div", _hoisted_99, [
                                        _withDirectives(_createVNode("select", {
                                          "onUpdate:modelValue": _cache[27] || (_cache[27] = $event => (_ctx.streetType = $event)),
                                          id: "streetTypeSelection",
                                          class: !_ctx.buildingType ? 'placeholder' : '',
                                          onChange: _cache[28] || (_cache[28] = $event => (_ctx.setStreetType(_ctx.streetType)))
                                        }, [
                                          _hoisted_100,
                                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.streetTypeList, (s) => {
                                            return (_openBlock(), _createBlock("option", {
                                              value: {id: s.id, name: s.description}
                                            }, _toDisplayString(s.description), 9, ["value"]))
                                          }), 256))
                                        ], 34), [
                                          [_vModelSelect, _ctx.streetType]
                                        ]),
                                        (_ctx.address.streetTypeName.trim() === '')
                                          ? (_openBlock(), _createBlock("span", _hoisted_101, [
                                              _hoisted_102,
                                              _hoisted_103
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.address.addressTypeId == 2)
                          ? (_openBlock(), _createBlock("div", _hoisted_104, [
                              _createVNode("div", _hoisted_105, [
                                _createVNode("div", _hoisted_106, [
                                  _hoisted_107,
                                  (_ctx.deliveryTypeList)
                                    ? (_openBlock(), _createBlock("div", _hoisted_108, [
                                        _withDirectives(_createVNode("select", {
                                          "onUpdate:modelValue": _cache[29] || (_cache[29] = $event => (_ctx.deliveryType = $event)),
                                          class: !_ctx.deliveryType ? 'placeholder' : '',
                                          id: "deliveryTypeSelection",
                                          onChange: _cache[30] || (_cache[30] = $event => (_ctx.setDeliveryType(_ctx.deliveryType)))
                                        }, [
                                          _hoisted_109,
                                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.deliveryTypeList, (dt) => {
                                            return (_openBlock(), _createBlock("option", {
                                              value: {id: dt.id, name: dt.name}
                                            }, _toDisplayString(dt.name), 9, ["value"]))
                                          }), 256))
                                        ], 34), [
                                          [_vModelSelect, _ctx.deliveryType]
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.address.deliveryTypeName === '')
                                    ? (_openBlock(), _createBlock("span", _hoisted_110, [
                                        _hoisted_111,
                                        _hoisted_112
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _createVNode("div", _hoisted_113, [
                                _createVNode("div", _hoisted_114, [
                                  _createVNode("div", _hoisted_115, [
                                    _hoisted_116,
                                    _withDirectives(_createVNode("input", {
                                      ref: "poBox",
                                      class: "po-box",
                                      type: "text",
                                      placeholder: "PO Box",
                                      "onUpdate:modelValue": _cache[31] || (_cache[31] = $event => (_ctx.address.poBox = $event)),
                                      maxlength: "50",
                                      onBlur: _cache[32] || (_cache[32] = $event => (_ctx.isPoBoxValid())),
                                      onKeyup: _cache[33] || (_cache[33] = $event => (_ctx.mandatoryCheck()))
                                    }, null, 544), [
                                      [_vModelText, _ctx.address.poBox]
                                    ]),
                                    (_ctx.address.poBox.trim() === '')
                                      ? (_openBlock(), _createBlock("span", _hoisted_117, [
                                          _hoisted_118,
                                          _hoisted_119
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.address.addressTypeId == 1 ||  _ctx.address.addressTypeId == 2)
                          ? (_openBlock(), _createBlock("div", _hoisted_120, [
                              _createVNode("div", _hoisted_121, [
                                _createVNode("div", _hoisted_122, [
                                  _hoisted_123,
                                  _withDirectives(_createVNode("input", {
                                    type: "text",
                                    ref: "suburbSearch",
                                    autocomplete: "new-name",
                                    "onUpdate:modelValue": _cache[34] || (_cache[34] = $event => (_ctx.query = $event)),
                                    maxlength: "50",
                                    onInput: _cache[35] || (_cache[35] = $event => (_ctx.formDirty = true)),
                                    onKeydown: [
                                      _cache[36] || (_cache[36] = _withKeys((...args) => (_ctx.onArrowDown && _ctx.onArrowDown(...args)), ["down"])),
                                      _cache[37] || (_cache[37] = _withKeys((...args) => (_ctx.onArrowUp && _ctx.onArrowUp(...args)), ["up"])),
                                      _cache[38] || (_cache[38] = _withKeys((...args) => (_ctx.onEnter && _ctx.onEnter(...args)), ["enter"]))
                                    ],
                                    placeholder: "Enter Suburb name or Postcode"
                                  }, null, 544), [
                                    [_vModelText, _ctx.query]
                                  ]),
                                  _createVNode("span", _hoisted_124, [
                                    (_ctx.isSearching)
                                      ? (_openBlock(), _createBlock("i", _hoisted_125))
                                      : _createCommentVNode("", true)
                                  ]),
                                  (_ctx.isOpen && _ctx.suburbList.length > 0)
                                    ? (_openBlock(), _createBlock("ul", _hoisted_126, [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.suburbList, (suburb, i) => {
                                          return (_openBlock(), _createBlock("li", {
                                            key: i,
                                            onClick: $event => (_ctx.selectSuburbFromSearch(suburb)),
                                            class: ["autocomplete-result", { 'is-active': i === _ctx.arrowCounter }],
                                            innerHTML: _ctx.highlightWord(suburb.postcode + ', ' + suburb.suburbName.trim() + ', ' + suburb.stateName)
                                          }, null, 10, ["onClick", "innerHTML"]))
                                        }), 128))
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _createVNode("div", _hoisted_127, [
                                _createVNode("div", _hoisted_128, [
                                  _hoisted_129,
                                  _createVNode("div", {
                                    class: "suburb",
                                    onClick: _cache[39] || (_cache[39] = $event => (_ctx.$refs['suburbSearch'].focus()))
                                  }, _toDisplayString(_ctx.address.suburbName), 1),
                                  (_ctx.address.suburbName == '')
                                    ? (_openBlock(), _createBlock("span", _hoisted_130, [
                                        _hoisted_131,
                                        _hoisted_132
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _createVNode("div", _hoisted_133, [
                                  _hoisted_134,
                                  _createVNode("div", {
                                    class: "postcode",
                                    onClick: _cache[40] || (_cache[40] = $event => (_ctx.$refs['suburbSearch'].focus()))
                                  }, _toDisplayString(_ctx.address.postcode), 1),
                                  (_ctx.address.postcode == '')
                                    ? (_openBlock(), _createBlock("span", _hoisted_135, [
                                        _hoisted_136,
                                        _hoisted_137
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _createVNode("div", _hoisted_138, [
                                  _createVNode("div", _hoisted_139, [
                                    _hoisted_140,
                                    _createVNode("div", {
                                      ref: "state",
                                      class: "state",
                                      onClick: _cache[41] || (_cache[41] = $event => (_ctx.$refs['suburbSearch'].focus()))
                                    }, _toDisplayString(_ctx.address.stateName), 513),
                                    (_ctx.address.stateName == '')
                                      ? (_openBlock(), _createBlock("span", _hoisted_141, [
                                          _hoisted_142,
                                          _hoisted_143
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_144, [
                        _createVNode("div", _hoisted_145, [
                          _hoisted_146,
                          _withDirectives(_createVNode("textarea", {
                            class: "col-12 ml-0",
                            "onUpdate:modelValue": _cache[42] || (_cache[42] = $event => (_ctx.address.foreignAddress = $event)),
                            maxlength: "500",
                            onKeyup: _cache[43] || (_cache[43] = $event => (_ctx.updatePreview()))
                          }, "\n                    ", 544), [
                            [
                              _vModelText,
                              _ctx.address.foreignAddress,
                              void 0,
                              { trim: true }
                            ]
                          ]),
                          (_ctx.address.foreignAddress === '')
                            ? (_openBlock(), _createBlock("span", _hoisted_147, [
                                _hoisted_148,
                                _hoisted_149
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])),
                  _createVNode("p", _hoisted_150, [
                    _hoisted_151,
                    _createVNode("pre", null, _toDisplayString(_ctx.getAddressEncoded), 1),
                    _createVNode("pre", null, _toDisplayString(_ctx.country.name), 1)
                  ]),
                  _hoisted_152
                ]),
                _createVNode("div", _hoisted_153, [
                  _renderSlot(_ctx.$slots, "footer", {}, () => [
                    _createVNode("div", _hoisted_154, [
                      _createVNode("button", {
                        class: "btn btn-tertiary",
                        onClick: _cache[44] || (_cache[44] = $event => (_ctx.resetForm()))
                      }, " Cancel "),
                      _createVNode("button", {
                        class: "btn btn-primary",
                        onClick: _cache[45] || (_cache[45] = $event => (_ctx.saveMyMemberDetail())),
                        disabled: !_ctx.canSubmit
                      }, [
                        _hoisted_155,
                        _hoisted_156
                      ], 8, ["disabled"])
                    ])
                  ], {}, true)
                ])
              ])
            ])
          ])
        ]),
        _: 3
      })
    ])
  ]))
})